//TODO: What utm variables are we tracking?
class UTM {
  constructor() {
    this.url = new URL(window.location.href);
    this.elForms = document.querySelectorAll('.utm-form');
    this.data = {};
    this.init();
    this.debug();
  }

  init() {
    this.handleUtmValues();
    this.handleForms();
  }

  handleUtmValues() {
    if (this.utmValuesExist()) {
      
      if (this.getCookie('utm_cookie')) {

        // Check if the utm values have changed.
        if (this.getCookie('utm_cookie') != JSON.stringify(this.data)) {
          this.createCookie();
        }

      } else {
        this.createCookie();
      }

    }
  }

  // TODO: Refactor this whole mess.
  handleForms() {
    if (!this.getCookie('utm_cookie')) return;

    // Allow enough time for forms injected with scripts to execute.
    setTimeout( () => {

      let utmObject = JSON.parse(this.getCookie('utm_cookie'));
    
      this.elForms.forEach( elForm => {

        let formFields = JSON.parse(elForm.dataset.utm);
        let src = "";
  
        // Make sure the selected element is an iframe
        if (elForm.nodeName != "IFRAME") {
          elForm = elForm.querySelector('iframe');
        }

        let data = {
          elForm: elForm,
          utmObject: utmObject,
          formFields: formFields
        }

        let location = window.location.origin;

        // Is the iframe an external URL
        if (elForm.src.indexOf(location) == -1) {
          this.handleExternalForm(data);
        } else {
          this.handleLocalForm(data);
        }

      });

    }, 800);
  }

  /**
   * Handles form iframes with an external src.
   */
  handleExternalForm(data) {
    let url = new URL(data.elForm.src);

    if (url.href.indexOf('/def/')) {
      url.href = url.href.slice(0, url.href.indexOf('/def/') + 5);
      url.href += data.formFields.utm_source + "=" + data.utmObject.utm_source;
      url.href += "&" + data.formFields.utm_campaign + "=" + data.utmObject.utm_campaign;
    }

    data.elForm.src = url.href;
  }

  handleLocalForm(data) {
    let innerIframe = data.elForm.contentWindow.document;

    let elUtmSource = innerIframe.querySelector('#' + data.formFields.utm_source);
    let elUtmCampaign = innerIframe.querySelector('#' + data.formFields.utm_campaign);

    elUtmSource.value = data.utmObject.utm_source;
    elUtmCampaign.value = data.utmObject.utm_campaign;
  }

  /**
   * Check if all UTM parameters exist in the url
   */
  utmValuesExist() {
    let utm_source = this.url.searchParams.get('utm_source');
    let utm_campaign = this.url.searchParams.get('utm_campaign');
    this.data.utm_source = utm_source != null ? utm_source : false;
    this.data.utm_campaign = utm_campaign !== null ? utm_campaign : false;

    if (this.data.utm_source && this.data.utm_campaign) {
      return true;
    }

    return false;
  }

  createCookie() {
    document.cookie = 'utm_cookie=' + JSON.stringify(this.data);
  }

  getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else
    {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = dc.length;
        }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
  } 

  debug() {
    if (debug) {
      console.groupCollapsed('%c Header', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    }
  }
}